import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'filterListViewByIdentity'
})
export class FilterListViewByIdentityPipe implements PipeTransform {
	transform(
		listing: {
			id: number;
			identity: string;
			missions: any;
		}[],
		filteredIdentity: string
	): {
		id: number;
		identity: string;
		missions: any;
	}[] {
		// si pas de valeur pour le filtrage, renvoyer la liste originelle
		if (!filteredIdentity) {
			return listing;
		}

		// on ignore les espaces et les valeurs nulls
		const filteringValues = filteredIdentity
			.split(' ')
			.filter((value) => value && value.trim() !== '');

		// s'il ne reste rien après le filtre, renvoyer la liste originelle
		if (filteringValues.length === 0) {
			return listing;
		}

		// sinon, renvoyer la liste avec les valeurs matchant au moins une des valeurs de filtrage
		return listing.filter((weekData) => {
			for (let filterValue of filteringValues) {
				if (
					weekData.identity.toLowerCase().includes(filterValue.toLowerCase())
				) {
					return true;
				}
			}
			return false;
		});
	}
}
